import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import FormService from "../../../Services/Form.service";
const config = {
    loadOptions: (search, options) => {
        return FormService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data);
    },
    value: "id",
    label: "title",
};
export const FormSearch = makeSearch(config);
export const FormMultiSearch = makeMultiSearch(config);
